import { render, staticRenderFns } from "./GarageEdit.vue?vue&type=template&id=ae8c48d0&"
import script from "./GarageEdit.vue?vue&type=script&lang=js&"
export * from "./GarageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports